import React from 'react'
import { Box } from '@mui/material';

function TutoCBVideo() {
  const videoInfo = {
    title: 'Comment finaliser une intervention et encaisser un paiement ?',
    src: 'https://youtube.com/embed/CIV93vlCYgk'
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', md: '320px' },
        aspectRatio: '9/16',
      }}
    >
      <iframe
        width="100%"
        height="100%"
        title={videoInfo.title}
        src={videoInfo.src}
        allow="autoplay; encrypted-media;"
        allowFullScreen
      />
    </Box>
  );
}

export default TutoCBVideo